/*
 * AccountReroll — titres de carte complets, jamais coupes par « … ».
 *
 * genshin-custom.css coupe les titres avec une ellipse, ce qui masquait le
 * serveur et l'archetype — justement ce que l'acheteur cherche. On reduit donc
 * la police plutot que de tronquer.
 *
 * NOMBRE DE LIGNES SELON L'ECRAN. Sur desktop la colonne fait ~286px et
 * 2 lignes suffisent a 12,5px. Sur mobile elle tombe a 156px : imposer 2 lignes
 * poussait la police jusqu'au plancher de 9px, illisible, et 3 lignes ne
 * donnaient que 9,75px. Les titres AccountReroll font jusqu'a 89 caracteres
 * (54 chez genshinaccountsbay.com) : il leur faut 4 lignes pour tenir a 13px.
 * On autorise donc 4 lignes sous 750px — exactement le rendu du concurrent,
 * qui ne tronque jamais.
 *
 * LE CLAMP EST POSE EN INLINE, PAS EN CSS. genshin-custom.css contient
 * plusieurs regles concurrentes en !important sur ces liens, dont une en
 * « .card-wrapper .card__heading.h5 .full-unstyled-link { -webkit-line-clamp: 3 }
 * » qui gagnait sur toutes les surcharges raisonnables. Un style inline marque
 * important bat n'importe quelle feuille : on n'a plus de bataille de
 * specificite, et le script pose le meme nombre de lignes que celui qu'il
 * vient d'utiliser pour calculer la taille — les deux ne peuvent plus diverger.
 *
 * UNE SEULE TAILLE PAR GRILLE. Caler chaque titre separement laissait des
 * cartes voisines avec des polices differentes, ce qui se voit. On prend par
 * grille la taille dont le titre le plus long a besoin et on l'applique au
 * groupe entier ; chaque section est traitee a part pour qu'une collection
 * verbeuse ne rapetisse pas le reste de la page d'accueil.
 */
(function () {
  if (window.__arTitre2Lignes) return;   // price.liquid est rendu une fois par carte
  window.__arTitre2Lignes = true;

  var MAX = 13, MIN = 9, PAS = 0.25, INTERLIGNE = 1.3;
  var SEUIL_MOBILE = 750, LIGNES_MOBILE = 4, LIGNES_DESKTOP = 2;
  var SEL = '.card__heading a, .card__heading .full-unstyled-link';
  var GRILLE = 'ul.grid, .grid, [id^="shopify-section"]';
  var sonde = null;

  function lignesAutorisees() {
    return window.innerWidth < SEUIL_MOBILE ? LIGNES_MOBILE : LIGNES_DESKTOP;
  }

  function creeSonde() {
    sonde = document.createElement('div');
    sonde.setAttribute('aria-hidden', 'true');
    sonde.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;white-space:normal;';
    document.body.appendChild(sonde);
  }

  /** Plus grande taille, entre MIN et MAX, ou ce titre tient dans le nombre de lignes vise. */
  function tailleNecessaire(a, lignes) {
    a.style.removeProperty('font-size');
    var large = a.parentElement.getBoundingClientRect().width;
    if (!large) return MAX;

    var cs = getComputedStyle(a);
    sonde.style.width = large + 'px';
    sonde.style.fontFamily = cs.fontFamily;
    sonde.style.fontWeight = cs.fontWeight;
    sonde.style.letterSpacing = cs.letterSpacing;
    sonde.style.lineHeight = INTERLIGNE;
    sonde.textContent = a.textContent.replace(/\s+/g, ' ').trim();

    for (var px = MAX; px >= MIN; px -= PAS) {
      sonde.style.fontSize = px + 'px';
      if (sonde.offsetHeight <= px * INTERLIGNE * lignes + 1) return px;
    }
    return MIN;
  }

  function ajuste() {
    var liens = document.querySelectorAll(SEL);
    if (!liens.length) return;
    if (!sonde) creeSonde();
    var lignes = lignesAutorisees();

    var grilles = new Map();
    for (var i = 0; i < liens.length; i++) {
      var a = liens[i];
      if (!a.offsetHeight) continue;
      a.style.setProperty('-webkit-line-clamp', String(lignes), 'important');
      var g = a.closest(GRILLE) || document.body;
      if (!grilles.has(g)) grilles.set(g, []);
      grilles.get(g).push(a);
    }

    grilles.forEach(function (groupe) {
      var min = MAX;
      for (var i = 0; i < groupe.length; i++) {
        var px = tailleNecessaire(groupe[i], lignes);
        if (px < min) min = px;
      }
      for (var j = 0; j < groupe.length; j++) {
        /*
         * setProperty(..., 'important') est indispensable : genshin-custom.css
         * impose « font-size: inherit !important » sur ces liens, un style
         * inline ordinaire serait ignore.
         */
        if (min < MAX) groupe[j].style.setProperty('font-size', min + 'px', 'important');
        else groupe[j].style.removeProperty('font-size');
      }
    });
  }

  var minuteur;
  function planifie() { clearTimeout(minuteur); minuteur = setTimeout(ajuste, 120); }

  document.addEventListener('DOMContentLoaded', ajuste);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajuste);
  else window.addEventListener('load', ajuste);
  window.addEventListener('resize', planifie);
  window.addEventListener('orientationchange', planifie);

  /*
   * Dawn recharge la grille en AJAX (filtres, tri, pagination) : sans observer,
   * les produits arrives apres coup gardaient leur ellipse. On ignore les
   * mutations provoquees par la sonde elle-meme, sinon la boucle est infinie.
   */
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (sonde && (t === sonde || sonde.contains(t))) continue;
        planifie();
        return;
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();